module.exports = __webpack_public_path__ + "static/media/login-bg-image.9196b973.png";